export class User {
  id: number;
  username: string;
  password: string;
  firstName: string;
  lastName: string;
  role: Role;
  data?: any;
  userName?: string;
  userId?: string;
  operatorId: string;
}

export enum Role {
  SAPAdmin = "SAPAdmin",
  OperatorAdmin = "OperatorAdmin",
  OperatorUser = "OperatorUser",
  SAPUser = "SAPUser,",
  GroupAdmin = "GroupAdmin",
  GroupUser = "GroupUser",
  RiskAdmin = "RiskAdmin"
}
export class Users {
  user_id: string;
  operator_id: string | string[];
  password: string;
  user_name: string;
  status: string;
  role: string;
  operators : string[];
  invoice: boolean;
  "2fa": boolean;
  constructor(values: Object = {}) {
    //Constructor initialization
    Object.assign(this, values);
  }
}

export interface portalUsers {
  OperatorId: string;
  Password: string;
  Role: string;
  Status: string;
  UserId: string;
  UserKey: string;
  UserName: string;
  TwoFAEnabled?: boolean;
  QrCode?: string;
}
export interface changePassword {
  UserId: string;
  OldPassword: string;
  NewPassword: string;
  OperatorId: string;
  Password: "";
}
// export class Users {
//   user_id: string;
//   operator_id: string;
//   password: string;
//   user_name: string;
//   status: string;
//   role: string;

//   constructor(values: Object = {}) {
//     //Constructor initialization
//     Object.assign(this, values);
//   }

// }

export interface portalUsers {
  OperatorId: string;
  Password: string;
  Role: string;
  Status: string;
  UserId: string;
  UserKey: string;
  UserName: string;
}
export interface changePassword {
  UserId: string;
  OldPassword: string;
  NewPassword: string;
  OperatorId: string;
  Password: "";
}
